import {
  AutoComplete,
  Input,
  Tooltip,
  Breadcrumb,
  Select,
  Checkbox,
  message,
} from "antd";
// import { t } from "i18next";
import { ActiveIcon, InactiveIcon, AddIcon } from "../../../../asset/icons";
import {
  EditIcon,
  DeleteIcon,
  DetailIcon,
  SearchIcon,
  CloseIconSearch,
  Nst,
  St,
  Pu,
  Sh,
  Tf,
  EditDisabled,
  StartTripOn,
  StartTripOff,
  EndTripOn,
  EndTripOff,
} from "../../../../asset";
import style from "./AllTripList.module.css";
import CustomTable from "../../../../component/table/CustomTable";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constant/routeConstant";
import axios from "axios";
import {
  GROLOG_BASE_URL,
  GROLOG_ORDER_URL,
  GROLOG_URL,
} from "../../../../constant/apiConstant.js";
import Delete from "../../../../component/modal/ModalDelete";
import CustomPaging from "../../../../component/pagination/pagination";
import CustomTableScroll from "../../../../component/table/CustomTableScroll";
import _ from "lodash";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import { useSelector } from "react-redux";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import ModalStartEndTrip from "../../../../component/modal/ModalStartEndTrip";
import ModalSuccessAdd from "../../../../component/modal/ModalSuccessAdd";
import ModalFailedDelete from "../../../../component/modal/ModalFailedDelete";
import { LoadingOption, dropdownCustom, selectOption } from "../../../../component/select/SelectOption";
import moment from "moment";

const AllTripList = (props) => {
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const { t } = useTranslation();
  const [listData, setListData] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [dropdown, setDropdown] = useState([]);
  const [depot, setDepot] = useState();
  const [depotName, setDepotName] = useState();
  const [isFilter, setIsfilter] = useState(false);
  const [depot1, setDepot1] = useState();
  const [depotName1, setDepotName1] = useState();
  const [sorting, setSorting] = useState("asc");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [lims, setLims] = useState();
  const [searchRecommendation, setSearchRecommedation] = useState("");
  const [listRecommendation, setListRecommendation] = useState([]);
  const [filter, setFilter] = useState("");
  const [load, setLoad] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  // const [listData, setListData] = useState([]);
  const [dataCheck, setDataCheck] = useState([]);
  const [startOpen, setStartOpen] = useState(false);
  const [endOpen, setEndOpen] = useState(false);
  const [trip, setTrip] = useState([]);
  const [listTrip, srtListTrip] = useState([]);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [messages, setMessages] = useState("");
  const [pageDepot, setPageDepot] = useState(1)
  const [limitDepot,setLimitDepot] = useState(10)
  const [loading, setLoading] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [filterDepot, setFilterDepot] = useState("")
  const api = GROLOG_ORDER_URL;
  console.log(
    "datacheck",
    dataCheck?.map((el) => el.id)
  );
  console.log("datachecks", dataCheck);
  // const refresh = useSelector((state) => state.auth.refresh);
  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    // const api = "http://app.sbp:9038/v1/grolog";
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doGetParam = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const api = GROLOG_URL;
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    // const api = `http://app.sbp:9038/v1/grolog`;
    const api = GROLOG_ORDER_URL;

    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization: token,
    };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const onStart = async (result) => {
    let cek = [];
    // let id=
    dataCheck?.map((el) => {
      cek.push({
        id: el.id,
        updated_at: el.updated_at,
      });
    });
    let list_trip = { list_trip: cek };

    try {
      let tkn = token;
      let res = await doPost(`/all-trip/start-trip?${param}`, tkn, list_trip);
      // setSuccessModalOpen(true);
      // message.success(_.startCase("Success Start Trip"));
      setMessages("Success Start Trip");
      setDataCheck([]);
      setSuccessModalOpen(true);
      setStartOpen(false);
    } catch (err) {
      if (
        err.response.data.payload.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
        // setErr(err.response.data.payload.message)
      } else {
        // message.error(_.startCase(err.response.data.payload.message));
        setMessages(err.response.data.payload.message);
        setFailedModalOpen(true);
        setStartOpen(false);
      }
    }
  };

  const onEnd = async () => {
    let cek = [];
    // let id=
    dataCheck?.map((el) => {
      cek.push({
        id: el.id,
        updated_at: el.updated_at,
      });
    });
    let list_trip = { list_trip: cek };

    try {
      let tkn = token;
      let res = await doPost(`/all-trip/end-trip?${param}`, tkn, list_trip);
      // setSuccessModalOpen(true);
      setMessages("Success End Trip");
      setDataCheck([]);
      setSuccessModalOpen(true);
      setEndOpen(false);
    } catch (err) {
      if (
        err.response.data.payload.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
        // setErr(err.response.data.payload.message)
      } else {
        // message.error(_.startCase(err.response.data.payload.message));
        setMessages(err.response.data.payload.message);
        setFailedModalOpen(true);
        setEndOpen(false);
      }
    }
  };

  const fetchDepot = async () => {
    // let tkn = token;
    // let res2 = await doGet(
    //   `/depot-configuration/dropdown?page=1&limit=10`,
    //   tkn
    // );
    // setDropdown(res2?.data?.payload?.data);
    // setDepot(res2?.data?.payload?.data[0]?.id);
    // setDepotName(res2?.data?.payload?.data[0]?.value);
  };

  const getListDepot = async (page, limit, filter) => {
    let res2 = await doGetParam(
      `/depot-configuration?page=${page}&limit=${limit}${filter ? `&filter=depot_name lk ${filter}` : ""}&${param}`,
      token
    );
    let option =[]
    let list = res2?.data?.payload?.data;
    const currentDepot = [...dropdown];
    console.log("masuk");
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.depot_id,
          value: element.depot_name,
        };
        option.push(data);
      }
      setDropdown(selectOption(currentDepot, option, "value"));
    };
}
  const fetchData = async (data, pages) => {
    console.log("checkpages", pages);
    let tkn = token;
    setLoad(true);
    // setListData(
    //   dummy? dummy.map((v) => ({
    //         ...v,
    //         checked: false,
    //       }))
    //       : null
    // );
    let res2 = await doGetParam(
      `/depot-list-filter?page=1&limit=10&${param}`,
      tkn
    );
    let res = await doGet(
      `/all-trip?page=${
        pages ? pages : page
      }&limit=${limit}&filter=depot_id eq ${
        depot ? depot : res2?.data?.payload?.data[0]?.depot_id
      }${
        !isFilter
          ? ""
          : filter
          ? ", trip_name lk " + filter
          : data
          ? ", trip_name lk " + data
          : ""
      }&${param}`,
      tkn
    );
    let init = await doGet(
      `/all-trip/initiate?page=${
        pages ? pages : page
      }&limit=${limit}&filter=depot_id eq ${
        depot ? depot : res2?.data?.payload?.data[0]?.depot_id
      }${
        !isFilter
          ? ""
          : filter
          ? ", trip_name lk " + filter
          : data
          ? ", trip_name lk " + data
          : ""
      }&${param}`,
      tkn
    );
    let option =[]
    let list = res2?.data?.payload?.data;
    const currentDepot = [...dropdown];
    console.log("masuk");
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.depot_id,
          value: element.depot_name,
        };
        option.push(data);
      }
    }
      setDropdown(selectOption(currentDepot, option, "value"));
    
    setDepot1(res2?.data?.payload?.data[0]?.depot_id);
    setDepotName1(res2?.data?.payload?.data[0]?.depot_name);
    setListData(
      res?.data?.payload?.data === null
        ? null
        : res?.data?.payload?.data.map((value) => ({
            ...value,
            checked: false,
          }))
    );

    setInitiate(init?.data?.payload?.data);
    setLoad(false);
  };
  const handleChange = (value, id) => {
    setPage(1)
    setDepot(value);
    setDepotName(value);
    fetchData("", 1);
  };
  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  };

  useEffect(() => {
    // fetchDepot();
    fetchData();
  }, [page, limit, depot, depotName]);

  const onScrollDepot = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight || target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight+1 &&
      !loading
    ) {
      setLoading(true)
      setPageDepot(pageDepot+1)
      target.scrollTo(0, target.scrollHeight);
      getListDepot(pageDepot, limitDepot, filterDepot)
    }
  };

  const onChangeDepot = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    console.log("value",event.target);
    let filterSearch = value && `${value}`;
    setSearchValue(value)
    let filters = [filterSearch];
    filters = filters.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filters = filters.length !== 0 ? filters.join(", ") : undefined;
    const resetFilter = filters;
    setDropdown([])
    if (value.length >= 2) {
      console.log("value", value);
      setDropdown([])
      setFilterDepot(filters)
      setPageDepot(resetPage)
        setTimeout(() => {
          getListDepot(1,limitDepot,filters)
      }, 256); 
    } else if (!value) {
      setLoading(true)
      setDropdown([])
      setFilterDepot(resetFilter)
      setPageDepot(resetPage)
      getListDepot(1, limitDepot,filters)
    }
  };

  const handleEdit = (id) => {
    navigate(ROUTES.ALL_TRIP.EDIT, { state: id });
  };

  const handleDetail = (id) => {
    navigate(ROUTES.ALL_TRIP.DETAIL, { state: id });
  };

  const checkOne = (event, result) => {
    let value = event.target.checked;
    console.log("valchk", value, result);
    let id = result.id;
    let search = _.find(listData, (el) => el.id == id);
    let findIndex = _.findIndex(listData, (el) => el.id == id);
    let data = _.some(dataCheck, search);
    if (data) {
      let checkedFalse = [...listData];
      checkedFalse[findIndex] = {
        ...checkedFalse[findIndex],
        checked: false,
      };
      _.remove(dataCheck, search);
      setIsChecked(false);
      setListData(checkedFalse);
    } else {
      let checkedTrue = [...listData];
      checkedTrue[findIndex] = {
        ...checkedTrue[findIndex],
        checked: true,
      };
      _.pull(dataCheck, search);
      dataCheck.push(checkedTrue[findIndex]);
      setListData(checkedTrue);
      if (dataCheck.length === 10) {
        setIsChecked(true);
      }
    }
  };

  const checkAll = (event) => {
    let value = event.target.checked;
    if (value) {
      setListData(
        _.map(listData, (v) => {
          return {
            ...v,
            checked: true,
          };
        })
      );
      setDataCheck(
        _.map(listData, (v) => {
          return {
            ...v,
            checked: true,
          };
        })
      );
    } else {
      setListData(
        _.map(listData, (v) => {
          return {
            ...v,
            checked: false,
          };
        })
      );
      setDataCheck([]);
    }
    // antara !value
    setIsChecked(value);
  };
  console.log("checkstatus", dataCheck[0]?.status)

  const handleStart = (result) =>{
    setStartOpen(true)
    setDataCheck([result])
  }
  const handleEnd = (result) =>{
    setEndOpen(true)
    setDataCheck([result])
  }
  const dataSource = listData
    ? listData?.map((result) => ({
        // checkbox: (
        //   <div className={style.selectOptionContainer}>
        //     <Checkbox
        //       onChange={(v) => checkOne(v, result)}
        //       checked={isChecked || result.checked}
        //       disabled={
        //         // result.status !==1 && result.status!==2 &&
        //         !result.checked &&
        //         dataCheck
        //           ?.map((el) => el.delivery_associate_id)
        //           .indexOf(result.delivery_associate_id) !== -1 
        //           && dataCheck?.map((el) => el.status).indexOf(result.status) === -1
        // }
        //     />
        //   </div>
        // ),
        trip_name: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.trip_name}
          </span>
        ),
        plan_name: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.plan_name}
          </span>
        ),
        deliv: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.delivery_associate_id}
          </span>
        ),
        firstName: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.first_name}
          </span>
        ),
        lastName: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.last_name}
          </span>
        ),
        status: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.status === 5 ? (
              <>
                <div className="bg-gray-300 px-2 rounded-3xl w-20">
                  <p className=" font-roboto-medium text-lg font-normal text-white-100">
                    end trip
                  </p>
                </div>
              </>
            ) : (
              <img
                src={
                  result?.status === 1
                    ? Nst
                    : result?.status === 2
                    ? St
                    : result?.status === 3
                    ? Pu
                    : result?.status === 4
                    ? Sh
                    : result?.status === 6
                    ? Tf
                    : ""
                }
                alt="end-trip"
              />
            )}
          </span>
        ),
        start_time: (
          <span className="font-roboto text-lg text-[#222222]">
            {moment.parseZone(result?.start_time).locale("id").format("DD/MM/YYYY")} | {moment.parseZone(result?.start_time).locale("id").format("HH:mm")}
          </span>
        ),
        // delivery_type: (
        //   <span className="font-roboto text-lg text-[#222222]">
        //     {result?.delivery_type}
        //   </span>
        // ),
        no_item: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.no_of_item}
          </span>
        ),
        no_order: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.no_of_order}
          </span>
        ),
        left_capacity: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.left_capacity}
          </span>
        ),
        total_capital: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.total_capacity}
          </span>
        ),

        action: (
          <div className="flex gap-[26px]">
            <Tooltip title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
              <button
              // disabled={`${result?.status === 1 ? false : true}`}
              >
                <img
                  src={result?.status === 1 ? EditIcon : EditDisabled}
                  alt="edit"
                  onClick={() =>
                    result?.status === 1 ? handleEdit(result?.id) : ""
                  }
                />
              </button>
            </Tooltip>
            <Tooltip title={t("Start Trip")} color="#CF0000">
              <button
              >
                <img
                  src={result?.status === 1 ? StartTripOn : StartTripOff}
                  alt="edit"
                  onClick={() =>
                    result?.status === 1 ? handleStart(result) : ""
                  }
                />
              </button>
            </Tooltip>
            <Tooltip title={t("End Trip")} color="#CF0000">
              <button
              >
                <img
                  src={result?.status === 2 ? EndTripOn : EndTripOff}
                  alt="edit"
                  onClick={() =>
                    result?.status === 2 ? handleEnd(result) : ""
                  }
                />
              </button>
            </Tooltip>
            {/* <Tooltip title={t("Delete")} color="#CF0000">
              <button onClick={() => setModal(result, "trip")}>
                <img src={DeleteIcon} alt="del" />
              </button>
            </Tooltip> */}
            <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
              <button
                // onClick={() => handleDelete(result?.customer_id, result?.updated_at)}
                onClick={() => handleDetail(result?.id)}
              >
                <img src={DetailIcon} alt="det" />
              </button>
            </Tooltip>
          </div>
        ),
      }))
    : null;

  const ListColumn = [
    {
      width: 50,
      title: <div className={style.selectOptionContainer}></div>,
      dataIndex: "checkbox",
      key: "checkbox",
      render: (checkbox) => <span>{checkbox}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Trip Name")}
        </span>
      ),
      dataIndex: "trip_name",
      key: "trip_name",
      render: (trip_name) => <span>{trip_name}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Plan Name")}
        </span>
      ),
      dataIndex: "plan_name",
      key: "plan_name",
      // sorter: {
      //     compare: (a, b) => a.plan_name.localeCompare(b.plan_name)

      // },
      render: (plan_name) => <span>{plan_name}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Delivery Associate ID")}
        </span>
      ),
      dataIndex: "deliv",
      key: "deliv",
      render: (deliv) => <span>{deliv}</span>,
    },

    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:FIRST_NAME_FIELD")}
        </span>
      ),
      dataIndex: "firstName",
      key: "firstName",
      render: (firstName) => <span>{firstName}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:LAST_NAME_FIELD")}
        </span>
      ),
      dataIndex: "lastName",
      key: "lastName",
      render: (lastName) => <span>{lastName}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Status")}
        </span>
      ),
      dataIndex: "status",
      key: "status",
      render: (status) => <span>{status}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Start Time")}
        </span>
      ),
      dataIndex: "start_time",
      key: "start_time",
      render: (start_time) => <span>{start_time}</span>,
    },
    // {
    //   title: (
    //     <span className="font-roboto text-lg text-[#222222] font-medium">
    //       {t("Delivery Type")}
    //     </span>
    //   ),
    //   dataIndex: "delivery_type",
    //   key: "delivery_type",
    //   render: (delivery_type) => <span>{delivery_type}</span>,
    // },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("No. of Item")}
        </span>
      ),
      dataIndex: "no_item",
      key: "no_item",
      render: (no_item) => <span>{no_item}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("No. of Order")}
        </span>
      ),
      dataIndex: "no_order",
      key: "no_order",
      render: (no_order) => <span>{no_order}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Left Capacity(Kg")}
        </span>
      ),
      dataIndex: "left_capacity",
      key: "left_capacity",
      render: (left_capacity) => <span>{left_capacity}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Total Capital(Kg)")}
        </span>
      ),
      dataIndex: "total_capital",
      key: "total_capital",
      render: (total_capital) => <span>{total_capital}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:ACTION_FIELD")}
        </span>
      ), 
      width:250,
      dataIndex: "action",
      key: "action",
      fixed: "right",
      render: (action) => action,
    },
  ];

  const doSort = async (sort) => {
    setSorting(sort);

    if (sort) {
      setSorting(sort);
      fetchData(data, sort);
    }
  };

  // const handlePagination = async (page, limit) => {
  //   setPage({ page}, async () => {
  //     await fetchData(
  //     );
  //   });
  // };

  const handlePagination = (a, b) => {
    if (a && b) {
      setPage(a);
      setLimit(b);
    } else {
    }
  };

  const fetchRecommendation = async (
    page,
    limit,
    filters,
    mapping_principal_id
  ) => {
    // const { token, refresh_token, dispatch } = this.props;
    if (filters.length >= 1) {
      let tkn = token;
      let res = await doGet(
        `/all-trip/search?page=1&limit=10&filter=depot_id eq ${
          depot ? depot : depot1
        }, trip_name lk ${filters}&${param}`,
        tkn
      );
      setListRecommendation(res?.data?.payload?.data);
      // const params = { page, limit, filter };
      // const { ok, response } = await MustSellListService.searchRecommendation(
      //   token,
      //   refresh_token,
      //   params,
      //   dispatch
      // );

      // if (ok) {
      //   this.setState({ listRecommendation: response });
      // }
    }
  };

  const onSearchRecommendation = async (value) => {
    setSearchRecommedation(value);
    setIsfilter(true);
    if (value) {
      setSearchRecommedation(value);
      await fetchRecommendation(1, 10, value);
    } else {
    }
  };

  const onSelectRecommendation = (data) => {
    setPage(1)
    setFilter(data);
    fetchData(data, 1);
    setIsfilter(false);
  };

  const onClearRecommendation = (e) => {
    setIsfilter(false);
    console.log("satu", isFilter);
    setFilter(null);
    console.log("dua", filter);
    setSearchRecommedation("");
    console.log("tiga", searchRecommendation);
    setListRecommendation([]);

    console.log(
      "after set null",
      filter,
      searchRecommendation,
      listRecommendation
    );

    fetchData("");

    console.log("lima");
  };

  const options =
    listRecommendation &&
    listRecommendation.map((item) => ({
      value: item.value,
      label: item.value,
    }));

  const actModal = () => {
    setSuccessModalOpen(false);
    setFailedModalOpen(false);
    setStartOpen(false);
    setEndOpen(false);
    setMessages("");
    setDataCheck([]);
    fetchData();
  };

  const handleClose = ()=>{
    setStartOpen(false)
    setEndOpen(false)
    setDataCheck([])
  }
  return (
    <>
      {/* ${<div className="font-semibold">"Start"</div>} */}
      <ModalStartEndTrip
        visible={startOpen}
        message={`The trip status will change to "Start"
     and can't be edited`}
        title="Start Trip"
        titles="Start Trip"
        onClick={() => onStart()}
        action={() => handleClose()}
      />
      <ModalStartEndTrip
        visible={endOpen}
        message={`The trip status will change to "End"
     and can't be edited`}
        title="End Trip"
        titles="End Trip"
        onClick={() => onEnd()}
        action={() => handleClose()}
      />
      <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModal()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description={messages}
      />
      <ModalFailedDelete
        show={failedModalOpen}
        action={() => actModal()}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be added"
        description={messages}
      />
      <Delete
        data={data.updated_at}
        id={data.trip_id}
        delete={showDelete}
        title={data.first_name}
        url={"trip"}
        action={() => setShowDelete(false)}
        route={ROUTES.ALL_TRIP.LIST}
        refresh={() => fetchData()}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={3}
          menuLevel1={`Order`}
          menuLevel2={`Routes`}
          menuLevel3={`All Trip`}
        />

        <h1 className="font-sans-bold text-2xl" id="title">
          {t("All Trip")}
        </h1>

        <div
          className={
            style.headerContainer + " flex justify-between items-center"
          }
        >
          <div className="flex h-[47px] mr-1">
            <AutoComplete
              options={options}
              value={searchRecommendation}
              onChange={(value) => onSearchRecommendation(value)}
              onSelect={(value) => onSelectRecommendation(value)}
              //  allowClear={true}
            >
              <Input
                placeholder={t("Search Trip Name")}
                suffix={
                  <img
                    onClick={filter ? () => onClearRecommendation() : null}
                    src={filter ? CloseIconSearch : SearchIcon}
                    alt="search"
                  />
                }
                value={searchRecommendation}
                width={350}
                className="w-[350px] h-[47px]"
              />
            </AutoComplete>
            <Select
              className={style.selectContainer + " ml-3 w-[200px]"}
              // "w-[200px] ml-3"
              // size="large"
              // options={dropdown}
              value={depotName ? depotName : depotName1}
              onChange={(id, val) => handleChange(id, val)}
              onPopupScroll={(e) => onScrollDepot(e)}
              dropdownRender={(menu) =>
                dropdownCustom(
                  menu,
                  (value) => onChangeDepot(value),
                  searchValue
                )
              }
              >
              {!loading
                  ? dropdown
                  : [...dropdown]}
              </Select>
            {/* <PrimaryButton
              text={t("Start Trip")}
              styles="ml-3 mr-3"
              disabled={!dataCheck?.length || dataCheck[0]?.status !==1}
              action={() => setStartOpen(true)}
            />
            <SecondaryButton
              text={t("End Trip")}
              disabled={!dataCheck?.length || dataCheck[0]?.status !==2}
              action={() => setEndOpen(true)}
              // action={() => setPage(1)}
            /> */}
          </div>

          {/* <Link to={ROUTES.ALL_TRIP.ADD}> */}
          <PrimaryButton
          disabled={load}
            action={() =>
              navigate(ROUTES.ALL_TRIP.ADD, { state: depot ? depot : depot1 })
            }
            text={t("Add Trip")}
            prefixIcon={<AddIcon />}
          />
          {/* </Link> */}
        </div>
        {/* {!load ? ( */}
        <div className={style.tableContainer}>
          <CustomTableScroll
            columns={ListColumn}
            // scroll={{x:1500}}
            data={dataSource}
            showPagination={false}
          />
          <div className={style.containerPagination + " mt-[-45px]"}>
            <CustomPaging
              idLimit="ddlrowsperpagemustselllist"
              idPagination="btnpaginationmustselllist"
              // pagination={pagination}
              size="small"
              current={page}
              defaultCurrent={page}
              pageSize={limit}
              total={initiate && initiate?.count_data}
              pageSizeOptions={initiate && initiate?.valid_limit}
              onShowSizeChange={() => handlePagination()}
              handlePaging={(a, b) => handlePagination(a, b)}
              title={t("COMMON:ROW_PAGE")}
            />
          </div>
        </div>
        {/* ) : (
          "..loading"
        )} */}
      </div>
    </>
  );
};

export default AllTripList;
